/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
export var SIZE = {
  default: 'default',
  full: 'full',
  auto: 'auto'
};
export var SIZE_WIDTHS = {
  default: '500px',
  full: '100%',
  auto: 'auto'
};
export var ROLE = {
  dialog: 'dialog',
  alertdialog: 'alertdialog'
};
export var CLOSE_SOURCE = {
  closeButton: 'closeButton',
  backdrop: 'backdrop',
  escape: 'escape'
};